const imagesUrl = [
  `https://res.cloudinary.com/dot-pic/image/upload/v1659617513/Avatar_1_radq7o.png`,
  `https://res.cloudinary.com/dot-pic/image/upload/v1659617513/Avatar_2_qxdz3v.png`,
  `https://res.cloudinary.com/dot-pic/image/upload/v1659617513/Avatar_3_zaxygb.png`,
  `https://res.cloudinary.com/dot-pic/image/upload/v1659617513/Avatar_4_to6gi6.png`,
  `https://res.cloudinary.com/dot-pic/image/upload/v1659617513/Avatar_5_l0db0m.png`,
]
export default imagesUrl
